import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

const variants = {
    primary: 'bg-primary text-white hover:bg-opacity-95 shadow-[0_0_20px_rgba(79,70,229,0.35)]',
    secondary: 'bg-secondary text-white hover:bg-opacity-95',
    outline: 'border border-primary text-primary hover:bg-primary hover:text-white',
    glow: 'bg-transparent text-primary shadow-[0_0_15px_rgba(79,70,229,0.15)] border border-primary/50 hover:border-primary hover:shadow-[0_0_25px_rgba(79,70,229,0.35)]',
};

const Button = ({ children, variant = 'primary', className = '', ...props }) => {
    return (
        <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className={`px-6 py-3 rounded-full font-bold transition-all duration-300 ${variants[variant]} ${className}`}
            {...props}
        >
            {children}
        </motion.button>
    );
};

Button.propTypes = {
    children: PropTypes.node.isRequired,
    variant: PropTypes.oneOf(['primary', 'secondary', 'outline', 'glow']),
    className: PropTypes.string,
};

export default Button;
